<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-16 19:07:24
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/AspectRadio.vue
-->
<template>
    <div class="mt-5">
        <label class="flex items-center text-white text-sm mb-[10px]">
            {{ props.label || t('tools.aspectRatio') }}
            <ClientOnly v-if="props?.show_tips">
                <el-popover width="180" :content="tip_content || t('seo.textToImage.page.aspectRatio')
                    ">
                    <template #reference>
                        <img class="w-3 h-3 ml-2 cursor-help"
                            src="https://static.weryai.com/growth/image/4c8570087b6d87697059b93e7295b008.webp"
                            alt="info" />
                    </template>
                </el-popover>
            </ClientOnly>
        </label>
        <div class="grid grid-cols-4 gap-2 w-full">
            <button v-for="ratio in props.aspect_ratio_list" :key="ratio"
                @click="!isRatioDisabled(ratio) && (aspect_ratio = ratio)" :disabled="isRatioDisabled(ratio)" :class="[
                    'flex w-full aspect-square border border-white/[0.06] bg-[#1C1C20]  flex-col items-center justify-center rounded-[10px] duration-300 p-1 sm:p-2',
                    isRatioDisabled(ratio)
                        ? 'cursor-not-allowed opacity-50'
                        : 'cursor-pointer',
                    !isRatioDisabled(ratio) && aspect_ratio !== ratio
                        ? ' hover:!border-white/30'
                        : '',
                    !isRatioDisabled(ratio) && aspect_ratio === ratio
                        ? ' !border-white/50 !bg-white/10'
                        : '',
                ]">
                <div :class="[
                    'transition-colors duration-200',
                    isRatioDisabled(ratio)
                        ? 'text-[#4D505D]'
                        : 'text-white/20',
                ]" :style="getShapeStyle(ratio)"></div>
                <span :class="[
                    'mt-1 sm:mt-2 text-[10px] sm:text-xs font-medium transition-colors duration-200 leading-none',
                    isRatioDisabled(ratio)
                        ? 'text-sub-title'
                        : aspect_ratio === ratio
                            ? 'text-white'
                            : 'text-sub-title',
                ]">
                    {{ String(ratio).toLowerCase() === 'adaptive' ? t('tools.smart') : ratio }}
                </span>
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '../../composables/useI18n'

const props = withDefaults(
    defineProps<{
        aspect_ratio_list: Array<any>
        disabled_ratios?: Array<string>
        show_tips?: boolean
        tip_content?: string
        label?: string
    }>(),
    {
        aspect_ratio_list: () => [],
        disabled_ratios: () => [],
        show_tips: false,
        tip_content: '',
        label: '',
    }
)

const { t, locale } = useI18n()

const aspect_ratio = defineModel('aspect_ratio', {
    type: String,
    default: '9:16',
})

// 检查比例是否被禁用
const isRatioDisabled = (ratio: string) => {
    return props.disabled_ratios?.includes(ratio) || false
}

// 宽高比形状计算函数
const getShapeStyle = (ratio: string) => {
    // 保留原始选项值（如 `16:9(2k)`），仅提取前面的宽高比用于绘图
    const matched = String(ratio).match(/(\d+)\s*:\s*(\d+)/)
    const width = Number(matched?.[1] || 1)
    const height = Number(matched?.[2] || 1)
    const aspectRatio = width / height

    // 基础尺寸
    const baseSize = 20
    let shapeWidth = baseSize
    let shapeHeight = baseSize

    if (aspectRatio > 1) {
        // 横向矩形
        shapeWidth = baseSize
        shapeHeight = baseSize / aspectRatio
    } else if (aspectRatio < 1) {
        // 纵向矩形
        shapeWidth = baseSize * aspectRatio
        shapeHeight = baseSize
    }
    // 1:1 保持正方形

    return {
        width: `${shapeWidth}px`,
        height: `${shapeHeight}px`,
        backgroundColor: 'currentColor',
        borderRadius: '2px',
    }
}
</script>
<style scoped lang="less"></style>
